import {Dialog} from '@mui/material'
import styled from 'styled-components'
import theme, {colors} from '../../../../styles/theme'
import CloseIcon from '@mui/icons-material/Close'

export const StyledDialog = styled(Dialog)`
  margin-bottom: 40px;

  && .MuiDialog-paper {
    border-radius: 8px;
  }
`

export const DialogTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 32px;
  color: ${colors.bksBlack};
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 38px;
  font-family: Freight Disp Pro;
  justify-content: center;
  text-align: center;
`
export const DialogText = styled.p<{size: 'small' | 'large'}>`
  margin: 0;
  padding: 0;
  ${({size}) =>
    size === 'small'
      ? `font-size: 14px; line-height: 20px; text-align: center;`
      : `font-size: 16px; line-height: 24px;`}
  color:${colors.bksGray80};
`

export const DialogBox = styled.div`
  padding: 0 32px;
  width: 480px;
  height: 450px;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;

  ${theme.breakpoints.down('sm')} {
    width: 100%;
    height: auto;
    padding: 32px 20px 60px;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
`

export const ButtonBox = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 40px;
  width: 100%;
  gap: 16px;
  align-items: center;

  && button {
    width: 180px;
  }

  ${theme.breakpoints.down('md')} {
    flex-flow: column !important;
    && button {
      width: 100% !important;
    }
  }
`

export const StudyModeBox = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 32px;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    gap: 16px;
  }
`
export const StudyModeItem = styled.div<{
  $isActive?: boolean
  $isCentered?: boolean
  $isDisabled?: boolean
  $isRecommended?: boolean
}>`
  width: 160px;
  height: 194px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  align-items: center;
  box-sizing: border-box;

  ${({$isActive, $isRecommended, $isDisabled}) =>
    $isActive
      ? `border:2px ${colors.blue1} solid; background: #E8F3FD;`
      : $isRecommended
      ? `border:2px ${colors.bksGray80} solid;`
      : $isDisabled
      ? `border:2px ${colors.bksGray50} solid;`
      : `border:2px #EBEFFC solid;`}

  ${({$isCentered}) =>
    $isCentered ? `justify-content: center;` : `padding-top: 24px;`}

  &: hover {
    border: 2px ${colors.blue1} solid;
    background: #e8f3fd;
  }

  ${theme.breakpoints.down('sm')} {
    width: 100%;
    height: auto;
    padding-top: 16px;
  }
`

export const IconBox = styled.div`
  && img {
    height: 32px;
  }

  margin-bottom: 8px;
`

export const StudyModeTitle = styled.p<{$isDisabled?: boolean}>`
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  text-align: center;

  ${({$isDisabled}) =>
    $isDisabled ? `color: ${colors.bksGray50};` : `color: ${colors.bksGray80};`}
`

export const StudyModeText = styled.p<{$isDisabled?: boolean}>`
  margin: 0;
  font-size: 12px;
  line-height: 16.8px;
  margin-top: 4px;
  text-align: center;

  ${({$isDisabled}) =>
    $isDisabled
      ? `color: ${colors.bksGray50}; padding: 0 16px 0;`
      : `color: ${colors.bksGray80}; padding: 0 16px 16px;`}
`

export const BackButton = styled.div`
  cursor: pointer;
  color: ${colors.blue1};
  font-size: 14px;
  position: absolute;
  bottom: 24px;
  left: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ExamStatusBox = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
`

export const UpgradeBox = styled.div`
  background: ${colors.blue1};
  color: #fff;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 4px);
  margin-top: 8px;
  margin-bottom: -2px;
  border-radius: 0 0 6px 6px;
`
